const translations = {
  es: {
    badge: 'Disponible para nuevos desafíos', // Más pro que "trabajar"
    greeting: 'Hola, soy',
    tagline: 'Ingeniero Civil en Computación · Data Engineering · Full-stack Software Engineer',
    footer: `© ${new Date().getFullYear()} Alan · Desarrollado en React`,
    themeLight: 'Modo claro',
    themeDark: 'Modo oscuro',

    aboutTitle: 'Sobre mí',
    aboutP1:
      'Ingeniero Civil en Computación orientado a la creación de sistemas robustos, análisis de datos avanzado y optimización de procesos. Mi expertise técnico abarca desde lenguajes de bajo nivel como C y Java, hasta el desarrollo de flujos de datos complejos en Python y SQL.',
    aboutP2:
      'He liderado proyectos que integran automatización, modelos de Machine Learning y arquitecturas web modernas, siempre enfocado en la eficiencia operativa y la escalabilidad técnica.',

    contactTitle: 'Contacto',
    linkedinDesc: 'Perfil Profesional',
    projectsTitle: 'Proyectos',
    visitProject: 'Ver proyecto',
  },
  en: {
    badge: 'Open to new opportunities',
    greeting: "Hi, I'm",
    tagline: 'Computer Science Engineer · Data Engineering · Full-stack Software Engineer',
    footer: `© ${new Date().getFullYear()} Alan · Built with React`,
    themeLight: 'Light mode',
    themeDark: 'Dark mode',

    aboutTitle: 'About me',
    aboutP1:
      'Computer Science Engineer specialized in building robust systems, advanced data analysis, and process optimization. My technical expertise ranges from low-level programming in C and Java to developing complex data pipelines using Python and SQL.',
    aboutP2:
      'I have led projects integrating industrial automation, Machine Learning models, and modern web architectures, always focused on operational efficiency and technical scalability.',

    contactTitle: 'Contact',
    linkedinDesc: 'Professional Profile',
    projectsTitle: 'Projects',
    visitProject: 'Visit project',
  },
};

export default translations;
